module.exports = {
  "autoPageView": {
    "name": "Pageview",
    "class": "view",
    "properties": {
      "screen": "string"
    },
    "namespace": "developer-docs"
  },
  "pageView": {
    "name": "Pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "developer-docs"
  }
};